export default __webpack_public_path__ + "static/walgreens-20f3a1992cc4885c33b0722bf0a46d16.svg";